<template>
  <div v-if="asyncDataStatus_ready">

    <h2>
      Napake pri sinhroniziranih računih:
    </h2>
    <div v-if="errors">
      <v-row>
        <v-col
          cols="12" sm="6" lg="4"
          v-for="error of errors" :key="`${error.electronic_device}${error.year}`"
        >
          <InvoiceConsistencyErrorCard :error="error"/>
        </v-col>
      </v-row>
    </div>

    <v-row
      v-else
    >
      <v-col cols="12">
        <p class="text-center">
          Zaporedne številke sinhroniziranih računov si ustrezno sledijo
        </p>
      </v-col>
    </v-row>

    <div v-if="certificateWarnings.length">
      <h2>
        Opozorilo o izteku certifikata:
      </h2>
      <v-row>
        <v-col
          cols="12" sm="6" lg="4"
          style="display:flex;"
          v-for="warning of certificateWarnings" :key="warning.certificate"
        >
          <CertificateWarningCard :error="warning"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import InvoiceConsistencyErrorCard from '@/components/InvoiceConsistencyErrorCard'
import CertificateWarningCard from '@/components/CertificateWarningCard'
import asyncDataStatus from '@/mixins/asyncDataStatus'

export default {
  mixins: [
    asyncDataStatus
  ],
  components: {
    InvoiceConsistencyErrorCard,
    CertificateWarningCard
  },
  data () {
    return {
      certData: [
        {
          certificate: 1818181,
          company_name: 'Testxoxo',
          valid_from: 'blablabal',
          valid_to: 'bububbu',
          expired: false
        }
      ]
    }
  },
  computed: {
    errors () {
      return this.$store.state.companies.invoiceConsistency
    },
    certificateWarnings () {
      return this.$store.state.clientsCertificates.certificateWarning
    }
  },
  methods: {
    ...mapActions('companies', ['invoiceConsistency']),
    ...mapActions('clientsCertificates', ['getCertificateWarnings'])
  },
  created () {
    Promise.all([this.invoiceConsistency(), this.getCertificateWarnings()])
      .finally(() => {
        this.asyncDataStatus_fetched()
      })
  }
}
</script>
